import ClockIcon from 'components/elements/icons/ClockIcon'
import InformationContent from 'components/elements/items/InformationContent'
import RequestedTemplate from 'components/templates/RequestedTemplate'
import React from 'react'
import { QnStatesProps } from 'states/QnState'
import { StatesProps } from 'utils/commonHooks'
import { useServiceEndProcess } from '../../utils/commonHooks'
import { QnStateProps } from '../../states/QnState'

/**
 * QN-014: 案内不可通知画面
 */
const Impasse: React.FC<StatesProps> = (props: QnStatesProps) => {
  const [qnStateProps] = React.useState<QnStateProps>({
    ...props.state,
  })
  useServiceEndProcess(props)

  return (
    <RequestedTemplate
      title={'案内不可通知画面'}
      content={
        <InformationContent
          items={[
            {
              icon: <ClockIcon />,
              marginBottom: '10px',
            },
            {
              message: '画面を閉じてください',
              large: true,
            },
          ]}
        />
      }
      state={qnStateProps}
    />
  )
}

export default Impasse
